import { Box, Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import classNames from 'classnames';
import HelpLink from 'App/HelpLink';
import { IonPageStratus } from 'commons/components/IonPageStratus';
import { useResponsive } from 'commons/components/Responsive';
import { CAN_LINK_ABOUT_ABANDONED_CARTS } from 'commons/constants';
import useTranslationLanguage from 'commons/hooks/useTranslationLanguage';
import { ABANDONED_CART_ROUTES } from 'domains/Orders/AbandonedCart/abandonedCartRoutes';
import useTranslationOrders from 'domains/Orders/useTranslationOrders/useTranslationOrders';
import {
  SectionAppCardDomains,
  SectionAppCard,
} from 'domains/PartnersApps/components';
import emptyAbandonedCartsImage from './empty-abandoned-carts.png';
import './AbandonedCartsListEmpty.scss';

interface AbandonedCartsListEmptyProps {
  onClickConfig: () => void;
}

function AbandonedCartsListEmpty({
  onClickConfig,
}: AbandonedCartsListEmptyProps) {
  const t = useTranslationOrders();
  const { isMobile } = useResponsive();
  const language = useTranslationLanguage();

  const className = classNames(
    'stratus--abandoned-carts-list-empty-text-color',
    {
      'stratus--abandoned-carts-list-empty-center-text': isMobile,
    },
  );

  return (
    <IonPageStratus width="medium">
      <InitialScreen>
        <div className={className}>
          <InitialScreen.Hero
            subtitle={t('abandonedCarts.title').toUpperCase()}
            title={t('abandonedCarts.empty.title')}
            description={t('abandonedCarts.empty.description')}
            image={
              <img
                src={emptyAbandonedCartsImage}
                alt={t('abandonedCarts.title')}
                height={isMobile ? '198px' : '100%'}
                width={isMobile ? '198px' : '100%'}
              />
            }
            actions={
              <Button onClick={onClickConfig} appearance="primary">
                {t('abandonedCarts.empty.button')}
              </Button>
            }
          >
            <Box marginTop="6">
              <SectionAppCard
                source={ABANDONED_CART_ROUTES.abandonedCartList}
                appCategory="communication"
                domain={SectionAppCardDomains.ABANDONED_CARTS}
              />
            </Box>
          </InitialScreen.Hero>
          <Box
            display="flex"
            flexDirection="row"
            gap="2"
            justifyContent="center"
            mt="5"
            paddingTop="5"
          >
            <HelpLink
              title={t('abandonedCarts.helpLink')}
              linkURL={CAN_LINK_ABOUT_ABANDONED_CARTS[language]}
              currentViewTracking={t(
                'abandonedCarts.helpLink.aboutAbandonedCartsTrackingName',
              )}
              previousValue="abandoned_cart_list"
              icon="both"
              showInMobile
            />
          </Box>
        </div>
      </InitialScreen>
    </IonPageStratus>
  );
}

export default AbandonedCartsListEmpty;
